import { useEffect, useState } from 'react';

function useIpCountry() {
  const [country, setCountry] = useState(
    () => localStorage.getItem('preferredCountry') || null,
  );

  useEffect(() => {
    let cancelled = false;

    async function detect() {
      try {
        const res = await fetch('https://ipwho.is/?fields=country_code');
        const json = await res.json();
        if (!cancelled && json?.country_code) {
          setCountry(json.country_code);
          localStorage.setItem('preferredCountry', json.country_code);
          return;
        }
      } catch {}

      try {
        const res = await fetch('https://ipapi.co/json/');
        const json = await res.json();
        if (!cancelled && json?.country_code) {
          setCountry(json.country_code);
          localStorage.setItem('preferredCountry', json.country_code);
          return;
        }
      } catch {}

      if (!cancelled) {
        const m =
          (navigator.language || '').match(/-([A-Z]{2})$/i) ||
          (navigator.languages || [])
            .map((l) => l.match(/-([A-Z]{2})$/i))
            .find(Boolean);

        if (m?.[1]) {
          const code = m[1].toUpperCase();
          setCountry(code);
          localStorage.setItem('preferredCountry', code);
        }
      }
    }

    if (!country) detect();

    return () => {
      cancelled = true;
    };
  }, [country]);

  return country;
}

export default useIpCountry;
